

// Components
import Heading from '@/components/atoms/Heading/Heading';
import PreTitle from '@/components/atoms/PreTitle/PreTitle';

// Hooks
import useResponsive from '@/hooks/useResponsive';

// Other
import { type SectionPourQuiType } from '@/services/blocksSchema';

// Style
import styles from './SectionPourQui.module.css';

interface SectionPourQuiProps {
  preTitle: SectionPourQuiType['preTitle'];
  title: SectionPourQuiType['title'];
  image: SectionPourQuiType['image'];
  blockTitle: SectionPourQuiType['blockTitle'];
  blockDescription: SectionPourQuiType['blockDescription'];
  items: SectionPourQuiType['items'];
  blockEndText: SectionPourQuiType['blockEndText'];
}

function SectionPourQui({
  preTitle,
  title,
  image,
  blockTitle,
  blockDescription,
  items,
  blockEndText
}: SectionPourQuiProps) {
  const { isMobile } = useResponsive();

  return (
    <div className={styles.bg}>
      <div className={styles.container}>
        <div className={styles.body}>
          <div className={styles.text}>
            <PreTitle
              preTitle={preTitle}
              size='p1'
              color='light'
            />
            <Heading
              title={title}
              size={isMobile ? 'h4' : 'h2'} 
              Tag='h2'
              align='center'
            />
          </div>
          <div className={styles.block}>
            <div className={styles['block-content']}>
              <Heading
                title={blockTitle}
                size='h4'
                Tag='h4'
                color={isMobile ? 'light' : 'dark'}
              />
              <p className={styles['block-description']}>
                {blockDescription}
              </p>
              <div className={styles['block-items']}>
                {
                  items.map((item) => (
                    <div key={item.text} className={styles['block-item']}>
                      <img
                        src={item.icon.url}
                        alt={item.icon.alternativeText || ''}
                        className={styles['block-item-icon']}
                      />
                      {item.text}
                    </div>
                  ))
                }
                <div className={styles['block-item']}>
                  {blockEndText}
                </div>
              </div>
            </div>
            <img
              src={image.url}
              alt={image.alternativeText || ''}
              className={styles['block-image']}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionPourQui;
